import DrinkImage from "../DrinkImage";
import { Card, CardContent, CardHeader } from "../ui/card";

export default function DrinkCard({ drink, selection, selectDrink }) {
  return (
    <Card
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor:
          selection.drinkId === drink.id
            ? "hsl(var(--primary))"
            : "hsl(var(--muted))",
        color:
          selection.drinkId === drink.id
            ? "hsl(var(--primary-foreground))"
            : undefined,
        cursor: "pointer",
      }}
      onClick={() => {
        selectDrink(drink.id);
      }}
    >
      <CardHeader
        style={{
          padding: "0.25rem",
          textAlign: "center",
          paddingBottom: 0,
          fontWeight: "500",
        }}
      >
        {drink.name}
      </CardHeader>
      <CardContent
        style={{
          padding: "0.25rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          <DrinkImage
            drink={drink}
            style={{
              height: "5rem",
              maxWidth: "100%",
              objectFit: "contain",
            }}
            alt=""
          />
        </div>
        <div
          style={{
            textAlign: "center",
            fontWeight: "500",
            fontSize: "0.75rem",
          }}
        >
          {drink.alcoholVolume} %
        </div>
      </CardContent>
    </Card>
  );
}
